// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.dashboard {
	background: #FFF;
	min-height: calc(100dvh - 98px)
}

.mydatahelps .page-wrapper.full-width .dashboard {
	min-height: calc(100dvh - 48px)
}

.dashboard .section {
	padding-top: 32px;
}

.dashboard .section:first-child {
	padding-top: 0;
}

.dashboard .section .section-header {
	font-size: 34px;
	font-weight: bold;
	padding: 15px 16px 7px;
	line-height: 34px;
}

.dashboard .section .component .divider {
	margin-left: 16px;
	margin-right: 16px;
	background: #c8c7cc;
	height: 1px;
	margin-bottom: -1px;
}

.dashboard .section .component:last-child .divider {
	display: none;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/Dashboard.css"],"names":[],"mappings":";;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd","sourcesContent":["\n\n.dashboard {\n\tbackground: #FFF;\n\tmin-height: calc(100dvh - 98px)\n}\n\n.mydatahelps .page-wrapper.full-width .dashboard {\n\tmin-height: calc(100dvh - 48px)\n}\n\n.dashboard .section {\n\tpadding-top: 32px;\n}\n\n.dashboard .section:first-child {\n\tpadding-top: 0;\n}\n\n.dashboard .section .section-header {\n\tfont-size: 34px;\n\tfont-weight: bold;\n\tpadding: 15px 16px 7px;\n\tline-height: 34px;\n}\n\n.dashboard .section .component .divider {\n\tmargin-left: 16px;\n\tmargin-right: 16px;\n\tbackground: #c8c7cc;\n\theight: 1px;\n\tmargin-bottom: -1px;\n}\n\n.dashboard .section .component:last-child .divider {\n\tdisplay: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
